import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
function SvgComponent(props) {
  var color = props.color;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.1 2.87c0-.591.479-1.07 1.07-1.07h3.36c.59 0 1.07.479 1.07 1.07v3.36c0 .59-.48 1.07-1.07 1.07H3.17c-.591 0-1.07-.48-1.07-1.07V2.87zm1.07-.27a.27.27 0 00-.27.27v3.36c0 .149.12.27.27.27h3.36c.15 0 .27-.121.27-.27V2.87a.27.27 0 00-.27-.27H3.17zM2.1 9.47c0-.591.479-1.07 1.07-1.07h3.36c.59 0 1.07.479 1.07 1.07v3.36c0 .59-.48 1.07-1.07 1.07H3.17a1.07 1.07 0 01-1.07-1.07V9.47zm1.07-.27a.27.27 0 00-.27.27v3.36c0 .149.12.27.27.27h3.36c.15 0 .27-.121.27-.27V9.47a.27.27 0 00-.27-.27H3.17zM8.7 9.47c0-.591.479-1.07 1.07-1.07h3.36c.59 0 1.07.479 1.07 1.07v3.36c0 .59-.48 1.07-1.07 1.07H9.77a1.07 1.07 0 01-1.07-1.07V9.47zm1.07-.27a.27.27 0 00-.27.27v3.36c0 .149.12.27.27.27h3.36c.15 0 .27-.121.27-.27V9.47a.27.27 0 00-.27-.27H9.77zM8.59 5.258a1.002 1.002 0 010-1.416l2.133-2.133a1.001 1.001 0 011.416 0l2.133 2.133a1.001 1.001 0 010 1.416L12.14 7.391a1.001 1.001 0 01-1.416 0L8.59 5.258zm.566-.85a.201.201 0 000 .284l2.133 2.133a.201.201 0 00.284 0l2.133-2.133a.201.201 0 000-.285l-2.133-2.132a.201.201 0 00-.284 0L9.156 4.407z",
    fill: color !== null && color !== void 0 ? color : '#000',
    fillOpacity: 0.87
  }));
}
export default SvgComponent;